// extracted by css-extract-rspack-plugin
export default {"cls1":"EdgePill-cls1_8Xw","cls2":"EdgePill-cls2_hqK EdgePill-cls1_8Xw"};